module.exports = __webpack_public_path__ + "static/media/icon_auto.af0a9475.svg";